module.exports = __webpack_public_path__ + "img/experience-2.b205a8ef.jpeg";